{
    "dashboard": {
        "addDashboard": "Lägg till instrumentpanel",
        "alreadyExists": "En instrumentpanel med namnet {dashboardName} finns redan.",
        "confirmDeleteMessage": "Är du säker på att du vill ta bort",
        "copyDashboard": "Kopiera instrumentpanel",
        "copyDashboardSuccess": "Instrumentpanel har kopierats",
        "dashboard": "Instrumentpanel",
        "dashboardDesc": "Beskrivning av instrumentpanelen",
        "searchDashboards": "Sök instrumentpaneler",
        "dashboardId": {
            "noWidgetsInDashboard": "Det finns inga widgets i den här instrumentpanelen",
            "noWidgets": "Det finns inga widgets i ",
            "noWidgetsAdded": "Inga widgets har lagts till ännu.\nKlicka på en widget ovanför och \ndra och släpp den för att skapa nya widgets.",
            "updateRoleSuccess": "Roll har uppdaterats",
            "widget": {
                "addCondition": "Lägg till villkor",
                "barChart": "Stapel",
                "chartType": "Diagramtyp",
                "column": "Kolumn",
                "copyToDashboard": "Kopiera till instrumentpanel",
                "copyWidget": "Kopiera widget",
                "copyWidgetSuccess": "Widget har kopierats",
                "count": "Antal",
                "dataset": "Välj ett dataset för widgeten",
                "deleteCondition": "Ta bort villkor",
                "deleteWidgetSuccess": "Widget har tagits bort",
                "display": "Visa",
                "editWidget": "Redigera widget",
                "exportScheduled": "Export planerad. Du får en avisering när den är klar",
                "field": "Fält",
                "goAheadAndSearchForRecordsIn": "Sök efter poster i",
                "infoBox": "Infobox",
                "itemColor": "Objektfärg",
                "items": "Objekt",
                "label": "Etikett",
                "lineChart": "Linjediagram",
                "newWidget": "Ny widget",
                "noRecordsToDisplay": "Inga poster att visa.",
                "noDataAvailable": "Ingen data tillgänglig",
                "notLinked": "Inte länkad",
                "notPossibleToDownload": "För mycket data för att ladda ner",
                "noWidgets": "Det finns inga widgets ",
                "number": "Tal",
                "optionalDescription": "Valfri beskrivning av widgeten",
                "optionalDescriptionWidget": "Valfri beskrivning av widgeten",
                "show": "Visa",
                "table": "Tabell",
                "tabMenu": {
                    "addField": "Lägg till fältnamn",
                    "activeWidget": "aktiv widget",
                    "addRule": "Lägg till regel",
                    "addViewDetailsButton": "Lägg till Visa detaljer knapp",
                    "advancedFilter": "Avancerat filter",
                    "advancedCondition": "Avancerat villkor",
                    "advancedFilterInfoTooltip": "Detaljerad information om hur man skriver frågan",
                    "appName": "Appnamn",
                    "appUrl": "App-URL",
                    "advancedFilterQueryGuide": {
                        "and": "Och",
                        "andDescription": "Operatorn AND visar en post om alla villkor som separeras med AND är sanna.",
                        "andExample": "ItemType:Ext AND Status:[10 TO 20]",
                        "between": "Mellan",
                        "betweenDescription": "I SQL används operatorn BETWEEN för att filtrera värden inom ett intervall. Här använder du hakparenteser [ ] för inkluderande intervall.",
                        "betweenExample": "Status:[10 TO 20]",
                        "dateModifications": "Ändringar baserade på datum:",
                        "dateModificationsTitle": "1. Visa data som har ändrats under de senaste 3 dagarna",
                        "dateModificationsTitleEx": "__modified: [\"now-3d/d\" TO \"now/d\"]",
                        "dateModificationsTitle1": "2. Visa rader som skapades 2025-02-04",
                        "dateModificationsTitleEx1": "__created: \"2025-02-04\"",
                        "equalTo": "Lika med (=)",
                        "equalToDescription": "Hämtar poster där ItemNumber är 3000007.",
                        "equalToExample": "ItemNumber:3000007",
                        "example": "Exempel:",
                        "example1": "Exempel 1:",
                        "example2": "Exempel 2:",
                        "exists": "Finns",
                        "existsExample": "_ItemType:*",
                        "existsNotExists": "Finns / Finns inte",
                        "existsNotExistsDescription": "Det finns ingen direkt motsvarighet till EXISTS eller NOT EXISTS, men du kan använda frågor för att kontrollera om ett fält finns eller saknas.",
                        "greaterThan": "Större än (>)",
                        "greaterThanDescription": "Hämtar poster där Status är större än 20.",
                        "greaterThanExample": "Status:>10}",
                        "greaterThanOrEqualTo": "Större än eller lika med (>=)",
                        "greaterThanOrEqualToDescription": "Hämtar poster där Status är större än eller lika med 20.",
                        "greaterThanOrEqualToExample": "Status:>=10",
                        "in": "I",
                        "inDescription": "I SQL tillåter IN-operatorn att du anger flera värden. Här använder du en boolesk OR.",
                        "inExample": "ItemNumber:(3000007 OR 3000047)",
                        "introductionDescription": "Detta dokument är en guide till hur man skriver avancerade filterfrågor med syntax i OpenSearch.",
                        "introductionTitle": "Introduktion",
                        "lessThan": "Mindre än (<)",
                        "lessThanDescription": "Hämtar poster där Status är mindre än 20.",
                        "lessThanExample": "Status:<20",
                        "lessThanOrEqualTo": "Mindre än eller lika med (<=)",
                        "lessThanOrEqualToDescription": "Hämtar poster där Status är mindre än eller lika med 20.",
                        "lessThanOrEqualToExample": "Status:<=20",
                        "like": "Som",
                        "likeDescription": "I SQL används LIKE-operatorn för mönsterjämförelse. Här använder du jokertecken * och ?.",
                        "likeExample": "ItemNumber:300*",
                        "linkedSearchWidgetTitle": "Här är ett exempel på en länkad sökwidget",
                        "notEqualTo": "Inte lika med (!=)",
                        "notEqualToDescription": "Hämtar poster där ItemNumber inte är 3000007.",
                        "notEqualToExample1": "!ItemNumber:3000007",
                        "notEqualToExample2": "!ItemNumber:3000007",
                        "notExists": "Finns inte",
                        "notExistsExample": "-_ItemType:*",
                        "operatorsTitle": "Operatorer:",
                        "or": "OR",
                        "orDescription": "Operatorn OR visar en post om något av villkoren som separeras med OR är sant.",
                        "orExample": "ItemType:Ext OR (Status:[15 TO 25])",
                        "tagValue": "Exempel för taggvärde",
                        "tagValueExample": "ItemType: {'{{'} tags.[ItemType] {'}}'}",
                        "tagValueExample1": "ProductGroup: {'{{'} tags.[Product Group] {'}}'}",
                        "where": "Where",
                        "whereDescription": "I SQL används WHERE klausulen för att filtrera poster. Här gör du detta genom att ange fältnamn följt av ett värde att filtrera på.",
                        "whereExample": "ItemNumber:3000007"
                    },
                    "appearance": "Utseende",
                    "backgroundColor": "Bakgrundsfärg",
                    "boldText": "Fet text",
                    "charts": {
                        "barChart": "Stapeldiagram",
                        "cakeChart": "Cirkeldiagram",
                        "lineChart": "Linjediagram"
                    },
                    "chooseDataset": "Välj dataset",
                    "chooseWorkflow": "Välj arbetsflöde",
                    "chooseEvent": "Välj händelse",
                    "customBackgroundColor": "Anpassad bakgrundsfärg",
                    "data": "Data",
                    "dataFieldComparison": "Datafältsjämförelse",
                    "dataWarningRules": "Regler för datavarningar",
                    "defaultBackgroundColor": "Standardbakgrundsfärg",
                    "details": "Detaljer",
                    "filter": "Filter",
                    "filtersHeader": "Filter",
                    "fonts": "Typsnitt",
                    "fontSize": "Teckenstorlek",
                    "fontSizeForTitle": "teckenstorlek för titel",
                    "foregroundColor": "Textfärg",
                    "from": "Från",
                    "iconLeft": "Ikon vänster",
                    "iconLeftSize": "Ikonstorlek vänster",
                    "iconPosition": "Ikonposition",
                    "iconRight": "Ikon höger",
                    "iconRightSize": "Ikonstorlek höger",
                    "iconSize": "Ikonstorlek",
                    "linked": "länkad",
                    "linkedWidgets": "Länkade widgets",
                    "linkedWidgetsDescription": "Välj widgets som ska länkas till indata för widgeten",
                    "linkFrom": "Länkad från",
                    "linkFromFieldCaption": "Välj källwidget som ska användas som trigger för den aktuella widgeten",
                    "mandatoryDatasetForWidget": "Obligatoriskt dataset för widgeten",
                    "eventForWidget": "Händelsen som skickas från Länkad från används som datakälla",
                    "mandatoryField": "Obligatoriskt fält",
                    "name": "Namn",
                    "operators": {
                        "average": "Medel",
                        "max": "Max",
                        "min": "Min",
                        "sum": "Summa"
                    },
                    "optionalDescriptionOfTheDashboard": "Valfri beskrivning av instrumentpanelen",
                    "searchTableColumnsPlaceholder": "Sök tabellkolumner",
                    "tableColumn": "Tabellkolumner",
                    "select": "välj",
                    "selectAll": "Välj alla",
                    "dragDropTableColumns": "Dra och släpp för att ange kolumnordning. Minst en kolumn måste väljas.",
                    "selectDivider": "Välj avgränsare",
                    "selectIcon": "Välj ikon",
                    "selectIconSize": "Välj ikonstorlek",
                    "selectLeftIcon": "Välj vänster ikon",
                    "selectLinkedWidgets": "Välj länkade widgets",
                    "selectRightIcon": "Välj höger ikon",
                    "selectWidget": "Välj widget",
                    "showFilters": "Visa filter",
                    "showViewDetailsButton": "Visa detaljlänk",
                    "simpleFilter": "Enkelt filter",
                    "sqlBasedCodeQuery": "Fråga",
                    "closeSqlHelper": "Stäng frågehjälp",
                    "showSqlHelper": "Visa frågehjälp",
                    "tagFieldComparison": "Taggjämförelse",
                    "text": "Text",
                    "to": "Till",
                    "widgetData": "Widgetdata",
                    "widgetDataset": "Widgetdataset",
                    "widgetDescription": "Widgetbeskrivning",
                    "widgetName": "Widgetnamn",
                    "workflows": "Arbetsflöden",
                    "connectedWorkflow": "Kopplat arbetsflöde",
                    "workflowsInputSettings": "Inställningar för arbetsflödets indata",
                    "triggerExpression": "Triggeruttryck",
                    "triggerExpressionInfo": "JSONata uttryck som avgör indata till arbetsflödet. Kan innehålla ",
                    "triggerExpressionInfo1": " för länkad data\n",
                    "dataExpression": "Datauttryck",
                    "dataExpressionInfo": "Uttryck för att hämta data från arbetsflödets svar",
                    "descriptionExpression": "Beskrivningsuttryck",
                    "descriptionExpressionInfo": "Uttryck för att hämta beskrivningstext från arbetsflödets svar",
                    "workflowResultSettings": "Inställningar för arbetsflödesresultat",
                    "workflowResultSettingsInfo": "Alla inställningar nedan är ",
                    "workflowResultSettingsInfo1": " och tar antingen JSONpath eller JSONata uttryck",
                    "optional": "VALFRITT",
                    "detailsDataExpression": "Datauttryck för detaljer",
                    "detailsDataExpressionInfo": "Uttryck för att hämta data från arbetsflödets svar när man klickar på ",
                    "detailsDataExpressionInfo1": " i vissa widgets",
                    "viewDetails": "Visa detaljer",
                    "detailsTextExpression": "Textuttryck för detaljer",
                    "detailsTextExpressionInfo": "Uttryck för att hämta text som visas i stället för ",
                    "detailsTextExpressionInfo1": " i vissa widgets",
                    "detailsUrlExpression": "URL-uttryck för detaljer",
                    "detailsUrlExpressionInfo": "Uttryck för att hämta en URL som används när man klickar på ",
                    "detailsUrlExpressionInfo1": " i vissa widgets",
                    "schemaDefinitionExpression": "Schemadefinitionsuttryck",
                    "enableSelection": "Aktivera markering",
                    "multipleRows": "Flera rader",
                    "singleRow": "En rad",
                    "editableTable": "Redigerbar tabell",
                    "selectEditableFields": "Välj redigerbara fält",
                    "typeEditableFields": "Skriv och tryck Enter för att lägga till redigerbara fält",
                    "useDropdown": "Använd rullgardinsmeny",
                    "selectDropdownColumn": "Välj rullgardinskolumn",
                    "selectColumn": "Välj kolumn",
                    "dropdownColumnName": "Rullgardinskolumnnamn",
                    "enterColumnName": "Ange kolumnnamn",
                    "addDropdownValue": "Lägg till rullgardinsvärde",
                    "typeDropdownValues": "Skriv och tryck Enter för att lägga till värden",
                    "actions": "Åtgärder",
                    "manageActions": "Hantera åtgärder",
                    "actionSettings": "Inställningar för åtgärd",
                    "listOfActions": "Lista över åtgärder",
                    "addNewAction": "Lägg till ny åtgärd",
                    "noActionsYet": "Inga åtgärder ännu",
                    "actionName": "Åtgärdsnamn",
                    "actionDescription": "Åtgärdsbeskrivning",
                    "selectWorkflow": "Välj arbetsflöde",
                    "advancedWorkflowSettings": "Avancerade arbetsflödesinställningar",
                    "triggerAction": "Trigga åtgärd",
                    "triggerActionInfo": "JSONata uttryck som avgör indata till arbetsflödet. Kan innehålla $selected för valda data, $linked för länkad data",
                    "removeRowFromTable": "Ta bort rad från tabell",
                    "removeOnSuccess": "Ta bort vid lyckad åtgärd",
                    "removeOnFailure": "Ta bort vid misslyckad åtgärd",
                    "verifyBeforeAction": "Bekräfta före åtgärd",
                    "chooseChart": "Välj diagramtyp",
                    "eventHandling": "Händelsehantering",
                    "showOnEvent": "Visa vid händelse",
                    "hideOnEvent": "Dölj vid händelse",
                    "showOnEventDescription": "Håller widgeten dold tills denna händelse triggas",
                    "hideOnEventDescription": "Döljer widgeten när denna händelse triggas",
                    "transform": "Transformera",
                    "transformDescription": "Transformera indata innan visning med JSONata. $linked är sökvägen till händelsedata som skickas från källwidgeten.",
                    "event": "Händelse",
                    "loadWidgetData": "Ladda widgetdata när instrumentpanelen laddas",
                    "shouldNotLoad": "Ska inte initialt ladda data för denna widget",
                    "legacyDatasource": "Om du ändrar datakälla i den nya versionen kommer denna ändring att vara oåterkallelig. Det tillämpade arbetsflödet kommer då endast att fungera i den nya versionen och kommer inte längre vara kompatibelt med den äldre versionen"
                },
                "iconSize": {
                    "extraSmall": "Extra liten",
                    "small": "Liten",
                    "medium": "Medium",
                    "large": "Stor"
                },
                "updatedSuccessfully": "Widget har uppdaterats",
                "viewDetails": "Visa detaljer",
                "widgetDataset": "Widgetdataset",
                "widgetCustomTable": "Anpassad widgettabell",
                "widgetDatasource": "Widgetdatakälla",
                "widgetChartType": "Diagramtyp",
                "widgetWorkflow": "Widgetarbetsflöde",
                "widgetDescription": "Widgetbeskrivning",
                "widgetName": "Widgetnamn",
                "xAxis": "X-axel",
                "yAxis": "Y-axel",
                "last": "Sista",
                "first": "Första",
                "dataSource": {
                    "CUSTOM_TABLE": "Anpassad tabell",
                    "EVENT": "Händelse",
                    "WORKFLOW": "Arbetsflöde"
                },
                "selectCustomTable": "Välj anpassad tabell",
                "selectWorkflow": "Välj arbetsflöde",
                "selectEvent": "Välj händelse",
                "charts": {
                    "WIDGET_LINE_CHART": "Linjediagram",
                    "WIDGET_BAR_CHART": "Stapeldiagram",
                    "WIDGET_PIE_CHART": "Cirkeldiagram"
                },
                "linkedTo": "Länkad till",
                "itemSelected": "{item} objekt valt",
                "itemsSelected": "{item} objekt valda",
                "selectAction": "Välj åtgärd",
                "confirmExecute": "Är du säker på att du vill köra \"{actionName}\"?",
                "actionSuccessMsg": "{actionName} har utförts för de valda objekten.",
                "actionFailMsg": "{actionName} misslyckades, kontrollera loggen för arbetsflödet.",
                "exportItem": "Exportera {count} objekt",
                "exportItems": "Exportera {count} objekt",
                "exportTooltipSingle": "Ladda ner {count} rad till Excel",
                "exportTooltipMultiple": "Ladda ner {count} rader till Excel",
                "showAllItems": "Visa alla objekt",
                "failedToLoadTableData": "Misslyckades med att läsa in tabelldata",
                "failedToLoadDataForWidget": "Misslyckades med att läsa in data för {widgetType} - {widgetName}",
                "failedToLoadInfoboxData": "Misslyckades med att läsa in infoboxdata",
                "noRecordsFound": "Inga poster hittades",
                "notPossibleToDwonload": "Det gick inte att ladda ner filen.",
                "filterCompatibility": "Om du ändrar dessa filter i den nya versionen är ändringen oåterkallelig. \nFiltren kommer då bara att fungera i den nya versionen och inte längre vara \nkompatibla med den äldre versionen.",
                "noColumnsSelected": "Inga kolumner valda. Välj minst 1 kolumn för att se data.",
                "permissionError": "Det gick inte att hämta data. Nödvändiga behörigheter saknas",
                "tagPermissionError": "Det gick inte att hämta data. En nödvändig tagg saknas i taggjämförelsen",
                "notPossibleToLoadData": "Det går inte att ladda data"
            }
        },
        "dashboardName": "Namn på instrumentpanel",
        "dashboardWidgets": "Instrumentpanelens widgets",
        "dataset": "Välj ett dataset för widgeten",
        "deleteConfirmation": "Bekräfta borttagning",
        "deleteDashboardSuccess": "Instrumentpanel har tagits bort",
        "deleteWidgetSuccess": "Widget har tagits bort",
        "dragAndDropPreview": "Dra och släpp widgeten i förhandsgranskningen",
        "editDashboard": "Redigera instrumentpanel",
        "exitEditMode": "Avsluta redigeringsläge",
        "loadMore": "Ladda fler instrumentpaneler",
        "mandatoryField": "Obligatoriskt fält",
        "newDashboard": "Ny instrumentpanel",
        "noDashboardsOnSearch": "Inga instrumentpaneler matchade din sökning",
        "noRecords": "Inga poster att visa",
        "selectDashboard": "Välj instrumentpanel",
        "specialCharError": "Specialtecken: / $ *? {'{ }'} [] & % är inte tillåtna",
        "title": "Instrumentpaneler",
        "widgetDataset": "Widgetdataset",
        "widgetDescription": "Widgetbeskrivning",
        "widgetPlaceholder": "Widgetplatshållare",
        "widgetName": "Widgetnamn",
        "widgetNameCannotBeEmpty": "Widgetnamn får inte vara tomt.",
        "widgetPreview": "Widgetförhandsgranskning"
    },
    "menuItems": {
        "dashboard": "Instrumentpaneler"
    },
    "widget": {
        "addWidget": "Lägg till widget",
        "filters": {
            "convertedFilters": "Konverterade filterobjekt",
            "convertedAdvanced": "Konverterat avancerat filter",
            "editGroupName": {
                "title": "Redigera namn på filtergrupp",
                "label": "Nytt namn"
            },
            "header": "Filter",
            "and": "och",
            "rule": "Regel",
            "connectedWith": "(kopplad med {operator})",
            "newFilterName": "Nytt filter",
            "newFilterDescription": "",
            "newGroup": "Ny grupp",
            "addConditionsList": "Lägg till villkorslista",
            "addQuery": "Lägg till manuell fråga",
            "addFilterItem": "Lägg till filter",
            "filterSummary": "FILTERSAMMANFATTNING",
            "selectFields": "Fält",
            "selectCondition": "Villkor",
            "valueType": "Värdetyp",
            "provided": "Värde",
            "tag": "Tagg",
            "field": "Fält",
            "noConditions": "Inga villkor stöds för vald fälttyp",
            "startDate": "Startdatum",
            "endDate": "Slutdatum",
            "date": "Datum",
            "range": "Intervall",
            "logical": {
                "and": "OCH",
                "or": "ELLER"
            },
            "conditions": {
                "string": {
                    "EQUALS": "Lika med",
                    "GREATER_THAN": "Efter",
                    "GREATER_THAN_OR_EQUALS": "På eller efter",
                    "NOT_EQUALS": "Inte lika med",
                    "CONTAINS": "Innehåller",
                    "DOES_NOT_CONTAIN": "Innehåller inte",
                    "IS_BLANK": "Är tom",
                    "IS_NOT_BLANK": "Är inte tom",
                    "LESS_THAN": "Före",
                    "LESS_THAN_OR_EQUALS": "På eller före"
                },
                "array": {
                    "CONTAINS": "Innehåller",
                    "DOES_NOT_CONTAIN": "Innehåller inte"
                },
                "number": {
                    "EQUALS": "Lika med",
                    "NOT_EQUALS": "Inte lika med",
                    "LESS_THAN": "Mindre än",
                    "LESS_THAN_OR_EQUALS": "Mindre än eller lika med",
                    "GREATER_THAN": "Större än",
                    "GREATER_THAN_OR_EQUALS": "Större än eller lika med"
                },
                "date": {
                    "EQUALS": "Är den",
                    "NOT_EQUALS": "Är inte den",
                    "CONTAINS": "Innehåller",
                    "DOES_NOT_CONTAIN": "Innehåller inte",
                    "IS_BLANK": "Är tom",
                    "IS_NOT_BLANK": "Är inte tom",
                    "LESS_THAN": "Före",
                    "GREATER_THAN": "Efter",
                    "LESS_THAN_OR_EQUALS": "På eller före",
                    "GREATER_THAN_OR_EQUALS": "På eller efter"
                },
                "boolean": {
                    "EQUALS": "Är sann",
                    "NOT_EQUALS": "Är falsk",
                    "CONTAINS": "Är sann",
                    "NOT_CONTAINS": "Är falsk"
                }
            },
            "valueTypes": {
                "PROVIDED": "Manuell",
                "TAG": "Taggar",
                "FIELD": "Jämför",
                "CONTEXT": "Kontext",
                "RELATIVE_DATE": "Relativt datum"
            }
        },
        "filterTab": {
            "addFilter": "Lägg till filterregel",
            "editFilter": "Redigera filter",
            "deleteFilter": "Ta bort filter",
            "appliedFilter": "Filtrering är aktiverad",
            "legacyFilterInfo": "Filter från Vince Live v.1 används",
            "deleteFilterConfirmation": "Är du säker på att du vill ta bort filtret?",
            "filterDeleted": "Filter har tagits bort.",
            "noFilters": "Inga filter används för denna widget"
        },
        "connectedTo": "Ansluten till "
    },
    "widgetType": {
        "WIDGET_DISPLAY_BOX": {
            "label": "Visningswidget"
        },
        "WIDGET_INFO_BOX": {
            "label": "Infowidget"
        },
        "WIDGET_LINE_CHART": {
            "label": "Diagramwidget"
        },
        "WIDGET_SEARCH_BOX": {
            "label": "Inmatningswidget"
        },
        "WIDGET_TABLE": {
            "label": "Tabellwidget"
        },
        "WIDGET_MAP": {
            "label": "Kartwidget"
        },
        "WIDGET_WORKFLOW": {
            "label": "Arbetsflödeswidget"
        }
    }
}
